<template>
  <div class="home">

	  <el-carousel :interval="5000" arrow="always" height="709px">
	     <el-carousel-item v-for="item in banner" :key="item">
			
	  <div class="h-banner">
	<div class="h-banner-t">
		<div class="ban-tit">
				   <img src="../../assets/tm.png" />
		</div>
		<div class="ban-but">
				   <router-link :to="'/product/details?id='+item.inventoryId">
				    SHOW NOW >
					</router-link>
		</div>
	</div>
		 <img :src="item.originalPic" />
		
	  </div>
	     </el-carousel-item>
	   </el-carousel>

   <div class="home-ct">
	   <div class="home-show">
	   	   <div class="tit">
	   		   <h4>PRODUCKS SHOW</h4>
			   <div> <router-link to="/product/list"><img src="../../assets/icon2.png" /></router-link></div>
			   
	   	   </div>
	
	   	   <div class="con">
	   		   <ul>
				   
				   <li v-for="item in hans"> 
				   <router-link :to="'/product/details?id='+item.inventoryId">
					   <p>{{item.title}} <img src="../../assets/icon1.png"></p>
					   <p class="time">{{item.dTtime}}</p>
					   
					   </router-link>
				   </li>
			
				   <div class="clear"></div>
			   </ul>
	   	   </div>
	   </div>

	   <div class="home-arr" v-for="item in news">
		   
	   	   <div class="tit">
	   		   <h4>{{item.title}}</h4>
	   			  
	   	   </div>
	   	   <div class="con">
	   		   <ul>
				 
	   				   <li v-for="it in item.products">
						     <router-link :to="'/product/details?id='+it.inventoryId">
						  
						     <div class="skr">
								 
								   <el-tooltip class="item" effect="light" content="Select options" placement="left">
								    <img class="cart" @click.prevent="sandYart(it)" src="../../assets/cart.png" />
								    </el-tooltip>
								 <el-tooltip class="item" effect="light" content="Quick view" placement="left">
								<img class="cart" @click.prevent="finding(it)" src="../../assets/find.png" />
								  </el-tooltip>
								   <el-tooltip class="item" effect="light" content="Add to wishlist" placement="left">
								<img class="cart" @click.prevent="collect(it)" src="../../assets/like.png" />
								  </el-tooltip>
							 </div>
						
					
						   
						   <img class="fit" v-if="it.kucun==0" src="../../assets/sold_out.png" />
						   <div class="pic">
							   <img :src="it.img" />
						   </div>
						   <div class="txt">
							   <p>
{{it.title}}</p>
						   <p>
{{it.remark}} </p>
 <p class="time">
$ {{it.price_sale}} </p>
 
						   </div>
	   					 </router-link>		  
	   				   </li>
				
																	
	   				 
	   			   </ul>
				   <div class="all">
					     <router-link :to="'/product/list?id='+item.id">
					   <img src="../../assets/all.png" />
					   </router-link>
				   </div>
	   	   </div>
	   </div>
	   

   </div>
   <div class="banner2"> </div>
 
 
 
 <el-dialog
:visible.sync="dialogVisible"
   width="800"
  :before-close="handleClose"
>
 <div class="product-st" >
 	 
 			   <div class="pic">
 				  <div class="l1">
 					
 					 <div class="block">
 						<img :src="proImg" />
 					   </div>
 				  </div>
 			
 			   </div>
 			    <div class="txt">
 					<h2>{{pro.title}}</h2>
 					<div class="l3" v-if="pro.kucun==0"><img src="../../assets/stock.png"></div>
 					<div class="l4">
 						$ {{pro.price_sale}}
 						<span>Tax included</span>
 					</div>
 					<div class="l5">
 						 <el-input-number size="mini"  v-model="num"  :min="1" :max="10" ></el-input-number>
 						 <div class="cart-but" @click="sandYart">ADD TO CART</div>
 					</div>
 					<div class="wishlist">
 					
 						<div class="co2">
 						Share：
 													<a href="https://www.facebook.com/sharer.php?u=http://localhost:8080/" title="facebook" target="_blank">	<img src="../../assets/facebook.png" /></a>
 														
 													<a href="http://twitter.com/share?text=FuelMe&url=http://localhost:8080/" title="twitter" target="_blank"><img src="../../assets/twitter.png" /></a>
 						<a href="http://service.weibo.com/share/share.php?url=http://localhost:8080/&title=FuelMe" title="weibo" target="_blank"><img src="../../assets/weibo.png" /></a>
 						
 						</div>
 					
 					</div>
 				</div>
 </div>
 </el-dialog>

  </div>
</template>
<script>


export default {

  data() {
    return {
	
		
		num: 1,
		dialogVisible: false,
		info:'',
		news:[],
		notice:[],
		id:'',
		pro:'',
		proImg:'',
		hans:'',
		banner:''
	
		
    
    };
  },  mounted() {
	  

		this.sandMate();
		this.sandHans();
		this.sandAlt();
		this.sandCase();
		this.sandCart();
		
		},methods: {
			finding(it){
				
				this.proImg=it.img
				this.id=it.inventoryId
				this.dialogVisible=true
				this.sandCase()
			
			},
		
			
		sandCase(){
		
			this.$axios({
			  method: "post",
			  url: "service.php?action=product_detail",
			  data: {inventoryId:this.id},  
			}).then((res) => {
				let data=res.data;
			
				if(data.code==1){
					this.pro=data.data;
				}
			 
			});
		
		}, handleClose(done) {
			this.num=1
			done();
       
      },sandYart(it){
		  this.id=it.inventoryId
				if(window.localStorage.getItem('user')== "undefined"){
					  this.$router.push({ path: "/login" });	
					return
				}
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_add",
				  data: {inventoryId:this.id,num:this.num},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==1){
						this.$message.success(data.message);
					
					
					}else{
						this.$message.error(data.message);
					}
				 
				});
			},
			collect(it){
				this.id=it.inventoryId
							if(window.localStorage.getItem('user')== "undefined"){
								  this.$router.push({ path: "/login" });	
								return
							}
							this.$axios({
							  method: "post",
							  url: "service.php?action=product_collect",
							  data: {inventoryId:this.id,collect_type:0},  
							}).then((res) => {
								let data=res.data;
								
								if(data.code==1){
									this.$message.success(data.message);
								
								
								}else{
									this.$message.error(data.message);
								}
							 
							});
						},
			sandMate(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=index_channelPdts",
				  data: {},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
				
										
						this.news=data.data;
						
						
					}
				 
				});
			
			},sandAlt(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=index_index",
				  data: {},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
				
										
						this.banner=data.data.banners;
						
						
					}
				 
				});
			
			},sandHans(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=product_plist",
				  data: {is_index:1},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
				
										
						this.hans=data.data;
						
						
					}
				 
				});
			
			}
		}
};
</script>
<style lang="scss">

	 .el-carousel__item h3 {
	    color: #475669;
	    font-size: 18px;
	    opacity: 0.75;
	    line-height: 300px;
	    margin: 0;
	  }
	  
	  .el-carousel__item:nth-child(2n) {
	    background-color: #99a9bf;
	  }
	  
	  .el-carousel__item:nth-child(2n+1) {
	    background-color: #d3dce6;
	  }
.home{
	.home-ct{
		width: 1200px;
		margin: 0 auto;
	}
	.banner{
		width: 100%;
		height: 709px;
		background: url(../../assets/banner1.png);
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		
	}
	.tit{
		display: flex;
		justify-content: space-between;
		align-items: center;
		h4{
			font-size: 24px;
			font-weight: normal;
		}
	
	}
	.all{
		text-align: center;
		margin: 30px;
	}
	.banner2{
		width: 100%;
		height: 590px;
		background: url(../../assets/banner2.png) center center;
	
	}
	.h-banner{
		position: relative;
		
		.h-banner-t{
			width: 100%;
			text-align: center;
			position: absolute;
			top: 200px;
			z-index: 999;
			.ban-but{
				width: 190px;
				height: 48px;
				background: url(../../assets/but.png);
				background-size: 100%;
				text-align: center;
				line-height: 48px;
				margin-top: 20px;
				margin: 50px auto;
			}
			.ban-but:hover{
				background: url(../../assets/but2.png);
				background-size: 100%;
			}
		}
	}
	.skr{
		display:none;
		flex-direction: column;
		position: absolute;
		top: 20px;
		right: 20px;
		color: #FFFFFF;
		z-index: 999;
		width: 64px;
		height: 145px;
		justify-content: space-evenly;
		align-content: center;
		text-align: center;
		background: url(../../assets/menu1.png);
			.cart{
				width: 20px;
				margin: 0 auto;
			}
		
		
	}
	.home-show{
		margin-top: 30px;
		.con{
			margin: 50px 0;
			ul{
				
				li{
					width: 400px;
					float: left;
					position: relative;
				
					p{
						img{
							margin-left: 30px;
						}
					}
					.time{
						color: #999999;
						margin-top: 30px;
					}
				}
				
			
				
			}
		
		}
		
	}

	.home-arr{
		.con{

			ul{
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
				li{
					position: relative;
					width: 589px;
					height: 500px;
					border: 1px solid #EEEEEE;
					width: 49%;
					margin-top: 40px;
					
					.pic{
						width: 100%;
						height: 393px;
						overflow: hidden;
						img{
							width: 100%;
							height: 393px;
							transition: all 0.5s;
						}
						img:hover{
							 transform: scale(1.2);
						}
						
					
					}
					.txt{
						padding: 15px;
						line-height: 25px;
						.time{
							color: #494949;
						}
					}
					.fit{
						position: absolute;
						top: -16px;
						left: 30px;
						z-index: 999;
					}
				}
				li:hover{
					.skr{
						display:flex;
					}
				}
			
			}
		}
	}

	.product-st{

		display: flex;
	
		.item-acticve{
			background: #333333;
		}
		.pic{
			width: 613px;
			.l1{
				img{
					width: 613px;
					height: 410px;
				}
				
			}
			
		}
		.txt{
			flex: 1;
			padding: 20px 40px;
			.l3{
				margin: 20px 0;
				img{
					width: 141px;
					height: 36px;
					
				}
			}
			.l4{
				color: #2D2A2A;
				font-size: 24px;
				span{
					color: #7C7C7C;
					font-size: 20px;
					margin-left:10px;
				
				}
			}
			.l5{
				display: flex;
				margin-top: 20px;
				.cart-but{
					font-size: 14px;
					width: 131px;
					height:38px;
					line-height: 38px;
					background-color: #FB2C00;
					color: #FFFFFF;
					text-align: center;
					margin-left: 20px;
				}
			}
			.wishlist{
				border-top: 1px solid #dedede;
				margin-top: 100px;
				padding-top: 30px;
				color: #2D2A2A;
				font-weight: bolder;
				img{
					height: 20px;
					margin-right: 10px;
				}
				.co1{
					display: flex;
					margin-bottom: 20px;
				}
				.co2{
					display: flex;
				}
				
			}
		}
	}
}
</style>